import React, { Component } from "react";
import styled from 'styled-components';
import { Input, Button, Form, Select, Table, Modal, Upload, message } from "antd";
import { UploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import AccountAPI from '@/api/account';
import RoleAPI from '@/api/role';
import utils from '@/utils/auth';
const { confirm } = Modal;
const Container = styled.div`
  .search-wrapper {
    padding: 25px;
    margin-bottom: 30px;
    background-color: #fafafa;
    .search {
      display: flex;
      align-items: center;
      .search-input {
        width: 260px;
      }
    }
  }
`;
const ModalWrapper = styled.div`
  margin: 0 auto;
  padding: 0 40px;
  .item {
    display: flex;
    align-items: center;
    height: 40px;
    .label {
      position: relative;
      width: 100px;
      white-space: nowrap;
      &.required::before {
        content: '*';
        position: absolute;
        top: 10%;
        left: -8px;
        color: red;
        vertical-align: middle;
      }
      &::after {
        content: "";
        width: 100%;
        overflow: hidden;
        height: 0;
      }
    }
    .value {
      width: 200px;
    }
  }
  .tip {
    color: #666666;
    font-size: 12px;
  }
`;
const Explain = styled.div`
  color: #666;
  font-size: 14px;
  margin-top: 20px;
  p {
    margin-bottom: 5px;
  }
`;
class AccountManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams: {
        username: '',
        account: '',
        roleId: '',
        pageNum: 1,
        pageSize: 10
      },
      accountList: [],
      total: 0,

      roleList: [],

      importDataModalVisible: false, // 批量导入modal
      fileList: [],

      accountModalVisible: false, // 编辑modal
      showModalType: 'add',
      itemInfo: {},
    };
  }

  componentDidMount() {
    this.initAccountList();
    this.initRoleList();
  }

  initAccountList = () => {
    const { searchParams } = this.state;
    AccountAPI.queryAccountList(searchParams)
        .then(({ items: accountList, paginator }) => {
          const { totalCount: total } = paginator;
          this.setState({ accountList, total });
        });
  }

  initRoleList = () => {
    RoleAPI.queryRoleList()
        .then(roleList => {
          this.setState({ roleList });
        });
  }

  onSearch = () => {
    this.setState({
      searchParams: Object.assign(this.state.searchParams, { pageNum: 1 })
    }, this.initAccountList);
  }

  onPageChange = (current, pageSize) => {
    this.setState({ searchParams: Object.assign(this.state.searchParams, { pageNum: current, pageSize }) }, this.initAccountList);
  }

  onRemoveAccount = ({ accountId }) => {
    confirm({
      title: '账户删除后，对应账户将无法登录后台，是否确认删除当前账户?',
      icon: <ExclamationCircleOutlined />,
      onOk: () => {
        AccountAPI.deleteAccountItem({ accountId })
          .then(() => {
              this.initAccountList();
          });
      },
    });
  }

  showAccountModal = item => {
    const { roleNames = [] } = item;
    this.setState({
      showModalType: JSON.stringify(item) === '{}' ? 'add' : 'update',
      accountModalVisible: true,
      itemInfo: Object.assign({}, item, { roleName: roleNames.join('、') })
    });
  }

  // 监听账号input的变化
  onAccountChange = e => {
    const { itemInfo } = this.state;
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
      this.setState({
        itemInfo: Object.assign(itemInfo, { account: inputValue }),
      });
    }
  }

  onAccountSearch = e => {
    const { itemInfo } = this.state;
    const { value: account } = e.target;
    AccountAPI.queryAccountItem({ account })
        .then(accountInfo => {
          const { kdtName, roleNames } = accountInfo;
          this.setState({
            itemInfo: Object.assign({}, itemInfo, { kdtName, roleNames, roleName: roleNames.join('、') }),
          });
        });
  }

  accountInfoConfirm = () => {
    const { itemInfo } = this.state;
    const { account, password, kdtName, roleNames } = itemInfo;
    const roleName = roleNames.join(',');
    if (!account || !password) {
      return message.warning('请将账号信息填写完整');
    }

    if (!kdtName || !roleName) {
      return message.warning('未匹配到对应员工角色，请重新输入账号');
    }

    const params = {
      account,
      password,
      kdtName,
      roleName
    };
    AccountAPI.saveAccountItem(params)
        .then(() => {
          message.success('保存成功');
          this.setState({ accountModalVisible: false }, this.initAccountList);
        });
  }

  downLoadFile = () => {
    AccountAPI.getDownLoadTemplateFile()
        .then(({ data: res }) => {
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', '导入账户数据模版.xlsx'); // 设置下载文件的名称

          // 为了能够触发下载，需要将链接添加到DOM中，然后模拟点击
          document.body.appendChild(link);
          link.click();

          // 清理
          URL.revokeObjectURL(url);
          document.body.removeChild(link);
        });
  }

  onUploadFile = () => {
    const { fileList: [ file ] } = this.state;
    AccountAPI.exportAccountData({ file })
        .then(() => {
          message.success('文件上传成功,请稍后刷新查看导入状态');
          this.setState({ importDataModalVisible: false }, this.initAccountList);
        });
  }

  render() {
    const status = utils.checkUserHasBtnPermission(this.props.location.pathname);

    const { searchParams, accountList, total, roleList, importDataModalVisible, fileList, accountModalVisible, showModalType, itemInfo } = this.state;
    const columns = [
      {
        title: '账户名称',
        dataIndex: 'username',
        key: 'username',
      },
      {
        title: '账户',
        dataIndex: 'account',
        key: 'account',
      },
      {
        title: '关联角色',
        render: ({ roleNames }) => roleNames.join('、')
      },
      {
        title: '归属店铺',
        dataIndex: 'kdtName',
        key: 'kdtName',
      },
      {
        title: '操作',
        render: item => {
          return (
              <>
                <Button type="link" disabled={!status} onClick={() => this.showAccountModal(item)}>编辑</Button>
                <Button type="link" disabled={!status} onClick={() => this.onRemoveAccount(item)}>删除</Button>
              </>
          );
        }
      }
    ];

    return (
        <Container>
          <div className="search-wrapper">
            <div className="search">
              <Form layout="inline">
                <Form.Item label="账户名称">
                  <Input
                      allowClear
                      value={searchParams.username}
                      placeholder="请输入账户名称"
                      onChange={e => {
                        const value = e.target.value.trim();
                        this.setState({ searchParams: Object.assign(searchParams, { username: value }) });
                      }}
                  />
              </Form.Item>
              <Form.Item label="账户">
                  <Input
                      allowClear
                      value={searchParams.account}
                      placeholder="请输入账户"
                      onChange={e => {
                        const value = e.target.value.trim();
                        this.setState({ searchParams: Object.assign(searchParams, { account: value }) });
                      }}
                  />
                </Form.Item>
                <Form.Item label="关联角色">
                  <Select
                      allowClear
                      showSearch
                      style={{ width: 200 }}
                      value={searchParams.roleId}
                      options={[{ roleName: '全部', roleId: '' }, ...roleList]}
                      optionFilterProp="roleName"
                      placeholder="请选择角色"
                      fieldNames={{
                        label: 'roleName',
                        value: 'roleId'
                      }}
                      onChange={value => {
                        this.setState({ searchParams: Object.assign(searchParams, { roleId: value || '' }) });
                      }}
                  />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" onClick={this.onSearch}>查询</Button>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" disabled={!status} onClick={() => this.showAccountModal({})}>新建账户</Button>
                </Form.Item>
                <Form.Item>
                  <Button type="primary" disabled={!status} onClick={() => this.setState({ importDataModalVisible: true })}>批量导入</Button>
                </Form.Item>
              </Form>
            </div>
          </div>

          <div className="content-wrapper">
            <Table
                rowKey="accountId"
                columns={columns}
                dataSource={accountList}
                pagination={{
                  current: searchParams.pageNum,
                  pageSize: searchParams.pageSize,
                  total,
                  showTotal: total => `共${total}条`,
                  hideOnSinglePage: false,
                  onChange: this.onPageChange
                }}
            />
          </div>

          <Modal
            title={`${showModalType === 'add' ? '新增' : '编辑'}账户`}
            maskClosable={false}
            open={accountModalVisible}
            onOk={this.accountInfoConfirm}
            onCancel={() => this.setState({ accountModalVisible: false })}
          >
            <ModalWrapper>
              <div className="item">
                <span className="label">账号：</span>
                <div className="value">
                  <Input
                      value={itemInfo.account}
                      maxLength={11}
                      placeholder="请输入账号"
                      disabled={showModalType === 'update'}
                      onChange={this.onAccountChange}
                      onBlur={this.onAccountSearch}
                  />
                </div>
              </div>
              <div className="item">
                <span className="label">账号密码：</span>
                <div className="value">
                  <Input.Password placeholder="请输入密码，最长16位" maxLength={16} value={itemInfo.password}
                    onChange={e => {
                      const value = e.target.value;
                      this.setState({ itemInfo: Object.assign(itemInfo, { password: value }) });
                    }}
                  />
                </div>
              </div>
              <div className="item">
                <span className="label">归属店铺：</span>
                <div className="value">{itemInfo.kdtName || '-'}</div>
              </div>
              <div className="item">
                <span className="label">关联角色：</span>
                <div className="value">{itemInfo.roleName || '-'}</div>
              </div>

              {showModalType === 'add' && <div className="tip">注意：账号失焦后，根据账号搜索员工信息</div>}
            </ModalWrapper>
          </Modal>

          <Modal
              title="批量导入"
              maskClosable={false}
              open={importDataModalVisible}
              onCancel={() => this.setState({ importDataModalVisible: false })}
              footer={[
                  <Button
                    type="primary"
                    key="upload"
                    disabled={fileList.length === 0}
                    onClick={this.onUploadFile}
                  >
                    确认导入
                  </Button>
              ]}
          >
            <Upload
                maxCount={1}
                name="file"
                fileList={fileList}
                beforeUpload={file => {
                  this.setState({ fileList: [ file ] });
                  return false;
                }}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
              <Button icon={<UploadOutlined/>}>上传</Button>
              <span style={{ marginLeft: 10 }}>仅支持格式为.xlsx的Excel文件</span>
            </Upload>

            <Explain>
              <p>1. 下载<Button type="link" size="small" onClick={this.downLoadFile}>导入模版</Button></p>
              <p>2. 按照模版填写账户信息并保存</p>
              <p>3. 进入后台，点击【批量导入】完成上传</p>
            </Explain>
          </Modal>
        </Container>
    );
  }
}

export default AccountManage;
